import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicPcManagementIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() } d="M29,5H3A2,2,0,0,0,1,7V22a2,2,0,0,0,2,2H29a2,2,0,0,0,2-2V7A2,2,0,0,0,29,5Zm0,16a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V8A1,1,0,0,1,4,7H28a1,1,0,0,1,1,1Z"/>,
    <rect fill={ this.getColor() } style={{ fillRule: 'evenodd' }} x="14" y="24" width="4" height="2"/>,
    <rect fill={ this.getColor() } style={{ fillRule: 'evenodd' }} x="12" y="26" width="8" height="1"/>
  ]
  getViewBox = () => '0 0 32 32'
}
